export enum PasswordStrength {
    WEAK = "WEAK",
    MODERATE = "MODERATE",
    STRONG = "STRONG",
}
